import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setStatus("success");
      setEmail("");
      return;
    }

    try {
      const response = await fetch("https://readdy.ai/api/form/d975dhkut53jbls7kv20", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: formData.get("email") as string }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const msg = parsed?.meta?.message || parsed?.message || responseText || "Wystąpił błąd";
        if (msg.includes("spam") || msg.includes("form data is spam")) {
          setErrorMsg("Wystąpił błąd podczas wysyłania. Spróbuj ponownie.");
        } else {
          setErrorMsg(msg);
        }
        setStatus("error");
      }
    } catch {
      setErrorMsg("Nie udało się wysłać. Sprawdź połączenie i spróbuj ponownie.");
      setStatus("error");
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-100 mx-4 md:mx-8 mb-6 md:mb-8 rounded-2xl overflow-hidden">
      <div className="px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                <i className="ri-shopping-bag-3-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg md:text-xl font-bold text-background-50 tracking-tight">
                Kakobuy<span className="text-primary-400">Finds</span>
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-xs">
              Największa baza produktów i finds dla polskich kupujących. Odkrywaj, porównuj i kupuj mądrzej z Kakobuy Spreadsheet.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-foreground-700 flex items-center justify-center text-background-300 transition-colors">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-foreground-700 flex items-center justify-center text-background-300 transition-colors">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-foreground-700 flex items-center justify-center text-background-300 transition-colors">
                <i className="ri-telegram-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">Szybkie linki</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Strona główna</Link></li>
              <li><Link to="/artykul/kakobuy-spreadsheet-poradnik" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Poradnik Kakobuy</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">kakobuy sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Buy It Now</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">Kategorie</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Shoes</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Hoodies</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-background-200 text-sm transition-colors">Jackets</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">Newsletter</h4>
            <p className="text-foreground-400 text-sm mb-4">
              Bądź na bieżąco z najnowszymi znaleziskami i aktualizacjami arkusza.
            </p>
            <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Twój adres email"
                required
                className="flex-1 px-4 py-2.5 rounded-full bg-foreground-800 border border-foreground-700 text-background-100 text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="visually-hidden"
              />
              <button
                type="submit"
                className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-1.5"></i>
                Subskrybuj
              </button>
            </form>
            {status === "success" && (
              <p className="text-primary-300 text-xs mt-2">Dziękujemy za subskrypcję!</p>
            )}
            {status === "error" && (
              <p className="text-red-400 text-xs mt-2">{errorMsg}</p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-heading text-sm text-foreground-500">
            &copy; Kakobuy 2026 Wszelkie prawa zastrzeżone
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-background-300 text-sm transition-colors">Polityka prywatności</a>
            <a href="#" className="text-foreground-500 hover:text-background-300 text-sm transition-colors">Warunki korzystania</a>
            <Link to="/" className="text-foreground-500 hover:text-background-300 text-sm transition-colors">Strona główna</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}